module.exports = __webpack_public_path__ + "img/honor18.fd7aa738.png";